"use client";

import { signIn } from "next-auth/react";
import { Button } from "@/components/ui/Button";
import { Card, CardContent } from "@/components/ui/Card";

export default function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-sm">
        <CardContent className="flex flex-col items-center gap-6 py-10">
          <div className="text-center">
            <h1 className="text-xl font-semibold text-gray-900">
              Email Auto Followup
            </h1>
            <p className="mt-2 text-sm text-gray-500">
              Sign in to manage your email follow-ups
            </p>
          </div>
          <Button
            onClick={() => signIn("google", { callbackUrl: "/" })}
            size="lg"
            className="w-full"
          >
            Sign in with Google
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
